import Link from "next/link";

import { ArticleExcerpt } from "@/custom-types/Wordpress";
import createNewsTargetingObject from "@/utils/createNewsTargetingObject";
import { AdElement } from "@/utils/news/adUtils";

import Image from "@/components/Image";
import PageNavigationV2 from "@/components/PageNavigation";

import NewsArticleDate from "../NewsArticleDate";

type Props = {
  articles: ArticleExcerpt[];
  title?: string;
  totalCount: number;
  currentPage: number;
  totalPages: number;
  slug: string;
};

const ListLayout = ({
  title,
  articles,
  totalCount,
  currentPage,
  totalPages,
  slug,
}: Props) => {
  let adNumber = 0;

  const targeting = createNewsTargetingObject(slug);

  return (
    <>
      {title && (
        <h1
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      )}
      <p className="mb-xl">
        {totalCount} total articles&nbsp;-&nbsp;Page {currentPage} of{" "}
        {totalPages}
      </p>
      <ul>
        {articles.map((article, i) => {
          const canInsertAd =
            i === 0 || (i % 3 === 0 && i !== articles.length - 1);
          if (canInsertAd) {
            adNumber = adNumber + 1;
          }

          return (
            <>
              <li className="mb-xxl" key={article.id}>
                <Link className="row" href={article.link}>
                  <div className="col md:col-4 mb-md md:mb-none relative">
                    <Image
                      src={article.featuredMedia.url}
                      alt={article.featuredMedia.altText}
                      sizes={[544, 768, 175, 240, null, 240]}
                      ratio="rectangle"
                      disableLazyLoad={i < 3}
                    />
                  </div>
                  <div className="col md:col-8">
                    <h2 className="font-bold text-md -mt-xs">
                      {article.title}
                    </h2>
                    <div className="flex text-xs">
                      <span>{article.author}</span>
                      &nbsp;-&nbsp;
                      <NewsArticleDate date={article.date} />
                    </div>
                    <div
                      className="mt-sm text-sm"
                      dangerouslySetInnerHTML={{ __html: article.excerpt }}
                    />
                    <span className="underline text-xs -mt-sm block">
                      read more
                    </span>
                  </div>
                </Link>
              </li>
              {canInsertAd && (
                <li className="mb-xxl">
                  <AdElement adNumber={adNumber} targeting={targeting} />
                </li>
              )}
            </>
          );
        })}
      </ul>

      <PageNavigationV2
        currentPage={currentPage}
        pageInPath={true}
        totalPages={totalPages}
      />
    </>
  );
};

export default ListLayout;
